import { atom } from "jotai";

export const isCommandPaletteOpenAtom = atom(false);
export const isCreateTableOpenAtom = atom(false);
// The spreadsheet awaiting column mapping. The dialog is mounted once in the
// dashboard layout, so a CSV can be imported from any page.
export const importCsvFileAtom = atom<File | null>(null);
